import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PrescriptionIntakeFlow } from '@/components/prescriptions/PrescriptionIntakeFlow';

export const UserUploadPrescription = () => {
  const navigate = useNavigate();

  return (
    <PrescriptionIntakeFlow
      role="USER"
      onComplete={(data) => {
        const presId = data?.id;
        navigate(presId ? `/user/prescriptions/${presId}` : '/user/dashboard');
      }}
      onCancel={() => navigate('/user/dashboard')}
      onManualEntry={() => navigate('/user/dashboard')}
    />
  );
};

export default UserUploadPrescription;

